/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';

import SkeletonStyles from './SkeletonStyles';

const useStyles = makeStyles((theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,

    heading: {
        margin: '0 auto 20px auto',
        width: '25%',
        height: '25px',
        [theme.breakpoints.down('xs')]: {
            height: '15px',
        },
    },

    // Page Elements
    productGrid: () => ({
        '&--product-block': {
            paddingBottom: '60%',
            width: '100%',
            marginBottom: '14px',
        },
        '&--product-title': {
            width: '100%',
            height: '10px',
            marginBottom: '10px',
        },
        '&--product-price': {
            width: '50%',
            height: '10px',
            marginBottom: '10px',
        },
        '&--heading': {
            width: '60%',
            height: '30px',
            marginBottom: '16px',
        },
    }),
    margin: {
        marginTop: '20px',
    },
}));

const OfferInboxSkeleton = () => {
    const classes = useStyles();

    return (
        <div data-testid="OfferInboxSkeleton">
            <div className={`${classes.productGrid}--heading ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-block ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-title ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-title ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-price ${classes.textSM} ${classes.shimmer}`} />

            <div className={classes.margin} />

            <div className={`${classes.productGrid}--heading ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-block ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-title ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-title ${classes.textSM} ${classes.shimmer}`} />
            <div className={`${classes.productGrid}--product-price ${classes.textSM} ${classes.shimmer}`} />
        </div>
    );
};

export default OfferInboxSkeleton;
